import { useApi, useToaster, type ExpertCustomerStoryDetails, type CustomerStoryUpsertRequest } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

interface UpdateCustomerStoryInput {
    storyId: number;
    payload: Partial<CustomerStoryUpsertRequest>;
}

export function useUpdateCustomerStory() {
    const api = useApi();
    const toaster = useToaster();
    const queryClient = useQueryClient();

    return useMutation<ExpertCustomerStoryDetails, Error, UpdateCustomerStoryInput>({
        mutationKey: ["expert", "customer-stories", "update"],
        mutationFn: ({ storyId, payload }) => api.expert.updateCustomerStory({
            params: { story: storyId },
            body: payload,
        }),
        onSuccess: async (story) => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["expert", "customer-stories"] }),
                queryClient.invalidateQueries({ queryKey: ["expert", "customerStories"] }),
                queryClient.invalidateQueries({ queryKey: ["expert", "customer-stories", story.id] }),
            ]);
            toaster.create({ title: "Case study updated", type: "success" });
        },
        onError: (error) => {
            toaster.create({ title: error.message || "Failed to update case study", type: "error" });
        },
    });
}

export default useUpdateCustomerStory;
